import { SplitSupplyNoticeDownloadFormat } from '@ebalance/proto/bffuser/v1/split_supply_plan_model_pb'
import { useTranslation } from 'react-i18next'

import { Menu, TertiaryButton } from '@enechain/ecloud-designsystem'
import { FaChevronDownRegular } from '@enechain/ecloud-icons'

/** 1 つの電文 (XML 1 ファイル) に入れられる供給地点の上限 (BP 標準の M10 の件数)。 */
export const POINTS_PER_FILE = 100

type Props = {
  /** この通の供給地点の件数。 100 件を超える通は ZIP でしか落とせない。 */
  pointCount: number
  onDownload: (format: SplitSupplyNoticeDownloadFormat) => void
}

/**
 * 一覧の行の「ダウンロード」。 押すと XML / ZIP を選ぶ。 100 件を超える通は 100 件ずつの
 * ファイルに分かれるので、 XML 1 ファイルは選べない (選ぶと backend が拒否する形式を最初から出さない)。
 * ZIP は 100 件以下でも選べる (広域機関の提出口は ZIP を受け付ける)。
 */
export const NoticeDownloadMenu = ({
  pointCount,
  onDownload,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const needsSplit = pointCount > POINTS_PER_FILE
  return (
    <Menu
      content={[
        {
          label: needsSplit
            ? t('page:splitSupplyPlan.download.formatXmlSplitDisabled')
            : t('page:splitSupplyPlan.download.formatXml'),
          value: 'xml',
          disabled: needsSplit,
          onClick: () => {
            onDownload(SplitSupplyNoticeDownloadFormat.XML)
          },
        },
        {
          label: t('page:splitSupplyPlan.download.formatZip'),
          value: 'zip',
          onClick: () => {
            onDownload(SplitSupplyNoticeDownloadFormat.ZIP)
          },
        },
      ]}
    >
      {/* 行アクション列のボタンは文字を md (14px) に保つ (隣の「詳細」と揃える。 ProcurementPlanTable と同じ) */}
      <TertiaryButton
        fontSize="md"
        _open={{ '& svg': { transform: 'rotate(180deg)' } }}
        rightIcon={<FaChevronDownRegular />}
        size="sm"
      >
        {t('page:splitSupplyPlan.download.menuButtonLabel')}
      </TertiaryButton>
    </Menu>
  )
}
